import Vue from 'vue';
import GenericExtensionFormatting from './menu-items/GenericExtensionFormatting.vue';

const fromExtentionToSimpleMenuItemHOF = (ButtonSvg, isActiveString, toggleFunc) => {
	const originalProps = GenericExtensionFormatting.props || {};
	const originalComponents = GenericExtensionFormatting.components || {};

	return Vue.component('withSimpleMenuItems', {
		render(createElement) {
			return createElement(GenericExtensionFormatting, {
				components: {
					...originalComponents,
				},
				props: {
					ButtonSvg,
					editor: this.editor,
					isActiveString,
					toggleFunc,
				},
			});
		},
		props: { ...originalProps },
		// data() {
		// 	return {
		// 		fetchedData: null,
		// 	};
		// },
		// methods: {
		// 	handleChange() {
		// 		this.fetchedData = selectData(DataSource, this.$props);
		// 	},
		// },
		// mounted() {
		// 	DataSource.addChangeListener(this.handleChange);
		// },
		// beforeDestroy() {
		// 	DataSource.removeChangeListener(this.handleChange);
		// },
	});
};
const RichTextMenuItemsService = {
	fromExtentionToSimpleMenuItemHOF,
};

export default RichTextMenuItemsService;
